/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReservationRequest,
  GetDayAvailability200ResponseValueInner,
  GetRangeAvailability200ResponseValueInner,
  GetReservationFeatures200Response,
} from '../models/index';
import {
    CreateReservationRequestFromJSON,
    CreateReservationRequestToJSON,
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetRangeAvailability200ResponseValueInnerFromJSON,
    GetRangeAvailability200ResponseValueInnerToJSON,
    GetReservationFeatures200ResponseFromJSON,
    GetReservationFeatures200ResponseToJSON,
} from '../models/index';

export interface AutoassignTableRequest {
    diners: number;
    dateTime: string;
    zone?: string;
}

export interface CancelReservationRequest {
    reservationId: string;
}

export interface ChargePolicyRequest {
    reservationId: string;
}

export interface CreateReservationOperationRequest {
    createReservationRequest: CreateReservationRequest;
}

export interface GetDayAvailabilityRequest {
    date: string;
    partySize: number;
    ignoreReservationId?: string;
}

export interface GetMonthAvailabilityRequest {
    partySize: number;
    month: string;
    ignoreReservationId?: string;
}

export interface GetRangeAvailabilityRequest {
    startDate: string;
    endDate: string;
    partySize: number;
    ignoreReservationId?: string;
}

export interface RefundPolicyRequest {
    reservationId: string;
}

export interface UpdateReservationRequest {
    reservationId: string;
    createReservationRequest: CreateReservationRequest;
}

/**
 * 
 */
export class ReservationsApi extends runtime.BaseAPI {

    /**
     */
    async autoassignTableRaw(requestParameters: AutoassignTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['diners'] == null) {
            throw new runtime.RequiredError(
                'diners',
                'Required parameter "diners" was null or undefined when calling autoassignTable().'
            );
        }

        if (requestParameters['dateTime'] == null) {
            throw new runtime.RequiredError(
                'dateTime',
                'Required parameter "dateTime" was null or undefined when calling autoassignTable().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['diners'] != null) {
            queryParameters['diners'] = requestParameters['diners'];
        }

        if (requestParameters['dateTime'] != null) {
            queryParameters['dateTime'] = requestParameters['dateTime'];
        }

        if (requestParameters['zone'] != null) {
            queryParameters['zone'] = requestParameters['zone'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/reservations/autoassign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async autoassignTable(requestParameters: AutoassignTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.autoassignTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cancelReservationRaw(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling cancelReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelReservation(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async chargePolicyRaw(requestParameters: ChargePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling chargePolicy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/policy/charge/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chargePolicy(requestParameters: ChargePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chargePolicyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createReservationRaw(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling createReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bookings/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createReservation(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDayAvailabilityRaw(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayAvailability().'
            );
        }

        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getDayAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/availability/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDayAvailability(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }> {
        const response = await this.getDayAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMonthAvailabilityRaw(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getMonthAvailability().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling getMonthAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/availability/month`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMonthAvailability(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMonthAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRangeAvailabilityRaw(requestParameters: GetRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetRangeAvailability200ResponseValueInner>; }>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getRangeAvailability().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getRangeAvailability().'
            );
        }

        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getRangeAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/availability/range`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getRangeAvailability(requestParameters: GetRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetRangeAvailability200ResponseValueInner>; }> {
        const response = await this.getRangeAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationFeatures200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationFeatures200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationFeatures200Response> {
        const response = await this.getReservationFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async refundPolicyRaw(requestParameters: RefundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling refundPolicy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/policy/refund/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async refundPolicy(requestParameters: RefundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.refundPolicyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateReservationRaw(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservation().'
            );
        }

        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling updateReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bookings/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservation(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationRaw(requestParameters, initOverrides);
    }

}
